import { combineReducers } from "redux";
import Auth from "./auth";
import Setting from "./setting";

const appReducers = combineReducers({
    Auth,
    Setting
});

const rootReducer = (state, action) => {
    return appReducers(state, action);
};

export default rootReducer;
